namespace Dashboard {
    class AmendBookingPreviousSummary {
        constructor(
            private $scope: ng.IScope,
            private hotelService: Core.Hotels.HotelService,
            private dashboardBookingService
        ) {
            dashboardBookingService.getMybBooking()
                .then(booking => {
                    $scope.booking = booking;
                    let estabId: any = _.get(booking, 'Itinerary.Stays[0].Hotel.EstabId');
                    return hotelService.getHotel(undefined, estabId, undefined);
                })
                .then(hotel => {
                    $scope.hotel = hotel;
                    hotel.BookingRef = $scope.booking.BookingCore.BookingRef;
                });
        }
    }

    angular
        .module('dashboard')
        .directive('amendBookingPreviousSummary', (): ng.IDirective => ({
            restrict: 'E',
            controller: AmendBookingPreviousSummary,
            scope: {},
            templateUrl: 'partials/home/directivetemplate?type=amendBookingPreviousSummary'
        }));
}
